import { Building2, CreditCard, Settings, FileText } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const actions = [
    { icon: <Building2 size={22} color="#6366f1" />, bg: '#eef2ff', title: 'Add Daycare', sub: 'Register a new daycare', route: "/dashboard/add-daycare" },
    { icon: <CreditCard size={22} color="#22c55e" />, bg: '#f0fdf4', title: 'New Subscription', sub: 'Create a plan', route: "/dashboard/subscription" },
    { icon: <Settings size={22} color="#8b5cf6" />, bg: '#f5f3ff', title: 'Manage Modules', sub: 'Configure platform', route: "/dashboard/module" },
    { icon: <FileText size={22} color="#f59e0b" />, bg: '#fffbeb', title: 'Review Requests', sub: ' Pending approvals', route: "/dashboard/enquiry" },
]

function QuickActions() {
    const navigate = useNavigate()
    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 16 }}>
            {actions.map((a) => (
                <div key={a.title} style={{ background: '#fff', border: '1px solid #f0f0f0', borderRadius: 12, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer', boxShadow: '0 1px 4px rgba(0,0,0,0.05)', transition: 'box-shadow 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'}
                    onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.05)'}
                    onClick={() => navigate(a.route)}
                >
                    <div style={{ background: a.bg, borderRadius: 10, padding: 10, display: 'flex', flexShrink: 0 }}>{a.icon}</div>
                    <div>
                        <div style={{ fontWeight: 600, fontSize: 14, color: '#111' }}>{a.title}</div>
                        <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{a.sub}</div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default QuickActions
